/* eslint-disable */
import React from "react";

import { StyledButton } from "components/support";

const handlePosButton = () => {
  window.location.href = "https://www.pdvend.com.br/app/#/sales";
};
const navigation = {
  priority: 0,
  authorization: context => context.user.permissions.includes("sell"),
  custom: (
    <div key="PDV" className="text-center pt-sm pb-sm">
      <StyledButton secondary onClick={handlePosButton}>
        Ponto de Venda
      </StyledButton>
    </div>
  )
};

export {};



// WEBPACK FOOTER //
// ./src/components/app/pos/index.jsx